import React from 'react';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { selectAvailableAutodealCategories } from 'Douleutaras/redux/data/seller/sellerProfilesSlice';

import CategoryLink from './CategoryLink';
import './ServicesSection.scss';

export const ServicesSection = () => {
  const categories = useAppSelector(selectAvailableAutodealCategories);

  if (!categories.length) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return (
    <ul styleName="related-services">
      {categories.map(category =>
        <CategoryLink key={category.id} id={category.id} title={category.attributes.title} />
      )}
    </ul>
  );
};

export default ServicesSection;
